var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav-menu"},_vm._l((_vm.links),function(link){return _c('router-link',{key:link.name,attrs:{"to":link.route}},[_vm._v(" + "+_vm._s(link.name)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }